// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1-oUs","buttons":"Footer_buttons__2SQYK"};